'use strict';

var React = require('react');
var AggregatedItems = require('./aggregates/items.jsx');
// var AggregatedArticle = require('./aggregates/article.jsx');
// var AggregatedVideo = require('./aggregates/video.jsx');

var Aggregator = React.createClass({
    render: function() {
        var items = this.props.items;
        // var aggregates;

        // if (items.length > 1)
        //     aggregates = <AggregatedItems items={items} />;
        // else if (items[0].type === "materia")
        //     aggregates = <AggregatedArticle item={items[0]} />;
        // else if (items[0].type === "materia_video" || items[0].type === "video")
        //     aggregates = <AggregatedVideo item={items[0]} />;
        // else
        //     return null;
        if (items.length === 0) return null;
        return (
            <div className="aggregator">
                <AggregatedItems items={items} />
            </div>
        );
    }
});

module.exports = Aggregator;
